'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var icCheck = '/icon/ic_check/ic_check.png';
var icUncheck = '/icon/ic_uncheck/ic_uncheck.png';

var SelectList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SelectList, _Component);

  function SelectList() {
    (0, _classCallCheck3.default)(this, SelectList);
    return (0, _possibleConstructorReturn3.default)(this, (SelectList.__proto__ || (0, _getPrototypeOf2.default)(SelectList)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectList, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./CommonUI.scss');
      var _props = this.props,
          _props$data = _props.data,
          key = _props$data.key,
          data = _props$data.data,
          active = _props.active;

      return _react2.default.createElement(
        'div',
        { className: styles.selectList },
        data && data.length && data.map(function (v, i) {
          return _react2.default.createElement(
            'div',
            {
              className: styles.pItem + ' ' + styles.sublist + (active.indexOf(String(v.value)) !== -1 ? ' ' + styles.active : ''),
              key: 'sublist_' + i,
              onClick: function onClick() {
                return _this2.props.onClick(key, v);
              }
            },
            _react2.default.createElement(
              'span',
              null,
              v.label
            ),
            active.indexOf(String(v.value)) !== -1 ? _react2.default.createElement('img', { src: icCheck }) : _react2.default.createElement('img', { src: icUncheck })
          );
        })
      );
    }
  }]);
  return SelectList;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  active: _react.PropTypes.array,
  className: _react.PropTypes.string,
  onClick: _react.PropTypes.func
}, _temp);

SelectList.defaultProps = {
  data: {},
  active: [],
  className: ''
  // onClick: function(){},
};
exports.default = SelectList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/CategoryMobile/SelectList.js
// module id = 1547
// module chunks = 0